import classes from "./ImagesCarousel.module.css"

import image1 from '../public/HomePage/carousel-images/1.webp';
import image2 from '../public/HomePage/carousel-images/2.webp';
import image3 from '../public/HomePage/carousel-images/3.webp';
import image4 from '../public/HomePage/carousel-images/4.webp';
import image5 from '../public/HomePage/carousel-images/5.webp';
import image6 from '../public/HomePage/carousel-images/6.webp';
import image7 from '../public/HomePage/carousel-images/7.webp';
import image8 from '../public/HomePage/carousel-images/8.webp';

const images = [
  {src: image1, key: 1, studios: "Musik Studios"},
  {src: image2, key: 2, studios: "Locations"},
  {src: image3, key: 3, studios: "Videostudios"},
  {src: image4, key: 4, studios: "Fotostudios"},
  {src: image5, key: 5, studios: "Green Screen Studios"},
  {src: image6, key: 6, studios: "Band Studios"},
  {src: image7, key: 7, studios: "Podcast Studios"},
  {src: image8, key: 8, studios: "Home Studios"},
];


const ImagesCarouselAnimation = () => {

  return (
    <div className={classes.imagesCarouselContainer}>
      {images.map((image, index) => (
        <div key={image?.key} className={classes.imageWrapper}>
          <img src={image?.src} alt={`${index + 1}`}/>
          <div className={classes.overlayLink}>
            <div className={classes.textContainer}>
              <span>{image?.studios}</span>
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="12" 
                height="12" 
                viewBox="0 0 12 12" 
                fill="none"
                className={classes.arrowIcon}
              >
                <path d="M11.2402 0.800781V9.50098H9.84082V3.19141L1.67773 11.3545L0.6875 10.3643L8.85156 2.2002H2.54004V0.800781H11.2402Z" fill="white"/>
              </svg>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImagesCarouselAnimation;